var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{directives:[{name:"tippy",rawName:"v-tippy",value:({
    placement: _vm.placement,
    arrow: true,
    theme: 'light',
    maxWidth: '260px'
  }),expression:"{\n    placement: placement,\n    arrow: true,\n    theme: 'light',\n    maxWidth: '260px'\n  }"}],staticClass:"tooltip-icon",attrs:{"src":"/assets/icons/icon-i-purple.svg","title":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }